import React from 'react';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { Grid } from '@material-ui/core';
import {
  CheckCircleOutlineOutlined,
  SettingsOutlined
} from '@material-ui/icons';
import { useStyles } from '../useStyles';
import useUserActionLog, {
  CapaActivityType,
  Enum_Action_Button_Enum
} from '@hooks/useUserActionLog';
import { useHistory } from 'react-router-dom';

interface Props {
  onReadAllNotification: () => void;
}

const NotificationPopperHeader: React.FC<Props> = ({
  onReadAllNotification
}) => {
  const classes = useStyles();
  const history = useHistory();
  const { onInsertUserActionLogOne } = useUserActionLog();

  return (
    <Grid container className={classes.header}>
      <Grid
        container
        alignItems="center"
        wrap="nowrap"
        justifyContent="space-between"
      >
        <CustomizedTypography variant="h4" fontWeight="700" color="textPrimary">
          알림
        </CustomizedTypography>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          className={classes.btnGroup}
          spacing={2}
        >
          <Grid item>
            <CustomizedButton
              variant="text"
              color="default"
              onClick={onReadAllNotification}
            >
              <CheckCircleOutlineOutlined
                fontSize="small"
                className={classes.checkedCircle}
              />
              모두 읽음처리
            </CustomizedButton>
          </Grid>
          <Grid item>
            <CustomizedButton
              variant="text"
              color="inherit"
              onClick={() => {
                onInsertUserActionLogOne(
                  Enum_Action_Button_Enum.Button_Notification_Setting,
                  CapaActivityType.ButtonClick
                );
                //onClose();
                history.push('/mypage/notification');
              }}
            >
              <SettingsOutlined
                fontSize="small"
                className={classes.checkedCircle}
              />
              알림 설정
            </CustomizedButton>
          </Grid>
        </Grid>
      </Grid>
      <CustomizedTypography variant="subtitle2" color="textSecondary">
        알림은 도착일 이후 7일까지만 보관됩니다.
      </CustomizedTypography>
    </Grid>
  );
};

export default NotificationPopperHeader;
